import React, { useState, useEffect, useCallback, useRef } from "react";
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import Button from '@mui/material/Button';
import CachedIcon from '@mui/icons-material/Cached';
import AddCardIcon from '@mui/icons-material/AddCard';
import AssignmentReturnIcon from '@mui/icons-material/AssignmentReturn';
import AccountBalanceWalletOutlinedIcon from '@mui/icons-material/AccountBalanceWalletOutlined';
import CurrencyRupeeIcon from '@mui/icons-material/CurrencyRupee';
import Typography from '@mui/material/Typography';
import { FINANCIALCARDSUMMARYTITLE } from "../../core/constants/erpConstants";

export default function FinancialDataCardSummary({ data, action }) {

  const handleButtonClick = (type) => {
    console.log('handleButtonClick: ', type);
    action(type);
  };

  useEffect(() => {
    console.log("in useeffect fincardsummary: ", data);
  }, []);

  return (
    <div className="finInfoCard card">
      <div className="d-flex text-center">
        <div className="finCardSummaryPayIconDiv">
          {data.type === 0 ? (
            <Button size="small" onClick={() => handleButtonClick(data.type)}><AddCardIcon /></Button>
          ) : data.type === 1 ? (
            <Button size="small" onClick={() => handleButtonClick(data.type)}><AssignmentReturnIcon /></Button>
          ) : data.type === 2 ? (
            <Button size="small" onClick={() => handleButtonClick(data.type)}><AccountBalanceWalletOutlinedIcon /></Button>
          ) : data.type === 3 ? (
            <div className="ms-2">
            <span className="finInfoCardText mb-1">
              {data?.leftTitle}
            </span>
            <h6 className="" style={{ color: data?.leftTitle === FINANCIALCARDSUMMARYTITLE.TOTALWITHOUTDISCOUNT ? Number(data.leftAmount) < 0 ? 'rgb(199, 10, 10)' : 'black' : 'black' }}>
              {data ? `₹ ${data.leftAmount}` : '₹ 0.00'}
            </h6>
          </div>
          ) : (
            <Button size="small" onClick={() => handleButtonClick(data.type)}><CachedIcon /></Button>
            // <img className="finCardSummaryPayIcon-reload" src="/static/icons/refresh-icon.png" alt="Pay Now" onClick={() => handleButtonClick(data.type)} />
          )}
        </div>
        <div className="ms-2">
          <span className="finInfoCardText mb-1">
            {data?.title}
          </span>
          <h6 className="" style={{ color: (data?.title === FINANCIALCARDSUMMARYTITLE.TOTALBALANCE) ? Number(data.amount) < 0 ? 'rgb(199, 10, 10)' : 'Green' : 'black' }}>
            {data ? `₹ ${data.amount}` : '₹ 0.00'}
          </h6>
        </div>
      </div>
    </div>
  );
}


